<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-09-25 18:49:08
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-10 11:39:08
 * @FilePath: /chaoyongtuan/src/views/cooperativeShop/shopList/components/multiRegimental.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-dialog title="请确认团长账号" :visible.sync="visble" width="400px" :before-close="handleClose">
		<div class="tip-content">
			<i class="el-icon-info tips"></i>
			<div class=" font-h6-regular fz-12"
				>该店铺的商品存在于多个团长机构账号中，请确认以下要协作的团长账号，如需要取消协同请前往店铺的“绑定记录”中取消</div
			>
		</div>
		<div class="command-list">
			<div class="command-list-top">以下是您认领的商品中关联的不同团长账号：</div>
			<div class="font-h4-regular fz-14 mt-4 command-name">
				{{ commandContent }}
			</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="visble = false">取消</el-button>
			<el-button type="primary" @click="nextStep">我知道了，下一步</el-button>
		</span>
	</el-dialog>
</template>
<script>
import { textFormat } from '@/filters';
export default {
	props: {
		list: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			visble: false,
			commandList: [],
			outerShopId: '',
		};
	},
	computed: {
		commandContent() {
			return this.commandList.map(val => textFormat(val.authorityName, 10)).join('、');
		},
	},
	methods: {
		show(list, outerShopId) {
			this.visble = true;
			this.commandList = list;
			this.outerShopId = outerShopId;
		},
		handleClose() {
			this.visble = false;
		},
		nextStep() {
			let params = {
				outerShopId: this.outerShopId,
				authorityIds: this.commandList.map(val => val.authorityId),
			};
			this.$emit('nextStep', params);
		},
	},
};
</script>
<style lang="less" scoped>
.tip-content {
	display: flex;
	border: 1px solid #ffe2d7;
	padding: 12px 12px 12px 16px;
	border-radius: 4px;
	background: #fff0eb;
	.tips {
		position: relative;
		top: 3px;
		margin-right: 4px;
		color: @color-o;
		font-size: 14px;
	}
}
.command-list {
	margin-top: 12px;
	padding: 12px;
	background: @background-color-base;
	border-radius: 4px;
	.command-list-top {
		font-size: 14px;
		font-weight: 500;
		color: @color-text-primary;
	}
	.command-name {
		color: @color-text-regular;
	}
}
</style>
